
export default class {
    constructor($window) {
        this.$ = $window;
        this.resizeCallbacks = [];
        this.scrollCallbacks = [];
        this.$clickoffElements = [];
        this.clickoffCallback = null;
        this.resizeTimeout = null;
        this.scrollTimeout = null;
        this.scrollStack = 0;
        $window.resize(() => {
            if (this.resizeTimeout !== null) {
                clearTimeout(this.resizeTimeout);
            }
            this.resizeTimeout = setTimeout(() => {
                $.each(this.resizeCallbacks, function(i, callback) {
                    callback();
                });
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = null;
            }, 200);
        });
        $window.scroll(() => {
            if (this.scrollTimeout !== null) {
                clearTimeout(this.scrollTimeout);
            }
            let delay = 200;
            if (this.scrollStack++ < 50) {
                this.scrollStack = 0;
                delay = 0;
            }
            this.scrollTimeout = setTimeout(() => {
                $.each(this.scrollCallbacks, function(i, callback) {
                    callback();
                });
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = null;
                this.scrollStack = 0;
            }, delay);
        });
        $window.click((e) => {
            if (this.clickoffCallback) {
                let clickingOn = false;
                $.each(this.$clickoffElements, function(i, $clickoffElement){
                    if ($clickoffElement[0] === e.target || $clickoffElement.has(e.target).length > 0) {
                        clickingOn = true;
                    }
                });
                if ( ! clickingOn) {
                    this.clickoffCallback();
                    this.resetClickoff();
                }
            }
        });
    }
    resize(callback) {
        this.resizeCallbacks.push(callback);
    }
    scroll(callback) {
        this.scrollCallbacks.push(callback);
    }
    clickoff($elements, callback) {
        if (typeof $elements.jquery === 'string') {
            $elements = [$elements];
        }
        setTimeout(() => {
            this.$clickoffElements = $elements;
            this.clickoffCallback = callback;
        }, 100);
    }
    resetClickoff() {
        this.clickoffCallback = null;
        this.$clickoffElements = [];
    }
}




// WEBPACK FOOTER //
// ./scripts/lib/WindowPal.js